        $( "#overlay-menu" ).hoverIntent(function() {
            $( ".overlay" ).addClass('overlay-open');
            $( ".furnitureOverlay" ).removeClass('furnitureOverlay-open');
          	$( ".aboutOverlay" ).removeClass('aboutOverlay-open');
            $( ".designersOverlay" ).removeClass('designersOverlay-open');
            $( ".signInOverlay" ).removeClass('signInOverlay-open');
          	$( ".searchOverlay" ).removeClass('searchOverlay-open');
            $( ".countryOverlay" ).removeClass('countryOverlay-open');          
        });


        $( "#overlayCont" ).mouseleave(function() {
            $( ".overlay" ).removeClass('overlay-open');
        });
		$( "#overlay-menuSticky" ).hoverIntent(function() {
            $( ".overlay" ).addClass('overlay-open');
        });
        $( "#overlayCont" ).mouseleave(function() {
            $( ".overlay" ).removeClass('overlay-open');
        });


		$( "#SignInMenu" ).click(function() {
            $( ".signInOverlay" ).addClass('signInOverlay-open');
            $( ".overlay" ).removeClass('overlay-open');
            $( ".furnitureOverlay" ).removeClass('furnitureOverlay-open');
            $( ".aboutOverlay" ).removeClass('aboutOverlay-open');
            $( ".designersOverlay" ).removeClass('designersOverlay-open');
          	$( ".searchOverlay" ).removeClass('searchOverlay-open');
            $( ".countryOverlay" ).removeClass('countryOverlay-open');
        });

        $( "#signInCont" ).mouseleave(function() {
           $( ".signInOverlay" ).removeClass('signInOverlay-open');
        });


		$( "#searchMenu" ).click(function() {
            $( ".searchOverlay" ).addClass('searchOverlay-open');
            $( ".signInOverlay" ).removeClass('signInOverlay-open');
         	$( ".overlay" ).removeClass('overlay-open');
            $( ".furnitureOverlay" ).removeClass('furnitureOverlay-open');
            $( ".aboutOverlay" ).removeClass('aboutOverlay-open');
            $( ".designersOverlay" ).removeClass('designersOverlay-open');
            $( ".countryOverlay" ).removeClass('countryOverlay-open');
        });

        $( "#searchCont" ).mouseleave(function() {
            $( ".searchOverlay" ).removeClass('searchOverlay-open');
        });


		$( "#countryMenu" ).click(function() {
            $( ".countryOverlay" ).addClass('countryOverlay-open');
 			$( ".signInOverlay" ).removeClass('signInOverlay-open');
         	$( ".overlay" ).removeClass('overlay-open');
            $( ".furnitureOverlay" ).removeClass('furnitureOverlay-open');
            $( ".aboutOverlay" ).removeClass('aboutOverlay-open');
            $( ".designersOverlay" ).removeClass('designersOverlay-open');
          	$( ".searchOverlay" ).removeClass('searchOverlay-open');
        });

		jQuery('#countryCont').mouseleave(function(){}, function(e){
          if (e.target == this) {
            $( ".countryOverlay" ).removeClass('countryOverlay-open');
          }
          else {
            console.log('false');
          }
        });

       // $( "#countryCont" ).mouseleave(function() {
         //   $( ".countryOverlay" ).removeClass('countryOverlay-open');
       // });


		$( "#aboutMenu" ).hoverIntent(function() {
            $( ".aboutOverlay" ).addClass('aboutOverlay-open');
          	$( ".overlay" ).removeClass('overlay-open');
            $( ".furnitureOverlay" ).removeClass('furnitureOverlay-open');
            $( ".designersOverlay" ).removeClass('designersOverlay-open');
            $( ".signInOverlay" ).removeClass('signInOverlay-open');
            $( ".searchOverlay" ).removeClass('searchOverlay-open');
            $( ".countryOverlay" ).removeClass('countryOverlay-open');
        });

        $( "#aboutOverlayCont" ).mouseleave(function() {
            $( ".aboutOverlay" ).removeClass('aboutOverlay-open');
        });



		$( "#designersMenu" ).hoverIntent(function() {
            $( ".designersOverlay" ).addClass('designersOverlay-open');
          	$( ".overlay" ).removeClass('overlay-open');
            $( ".furnitureOverlay" ).removeClass('furnitureOverlay-open');
            $( ".aboutOverlay" ).removeClass('aboutOverlay-open');
            $( ".signInOverlay" ).removeClass('signInOverlay-open');
            $( ".searchOverlay" ).removeClass('searchOverlay-open');
            $( ".countryOverlay" ).removeClass('countryOverlay-open');
        });

        $( "#designersOverlayCont" ).mouseleave(function() {
            $( ".designersOverlay" ).removeClass('designersOverlay-open');
        });


		$( "#furnitureMenu" ).hoverIntent(function() {
            $( ".furnitureOverlay" ).addClass('furnitureOverlay-open');
          	$( ".overlay" ).removeClass('overlay-open');
            $( ".designersOverlay" ).removeClass('designersOverlay-open');
            $( ".aboutOverlay" ).removeClass('aboutOverlay-open');
            $( ".signInOverlay" ).removeClass('signInOverlay-open');
            $( ".searchOverlay" ).removeClass('searchOverlay-open');
            $( ".countryOverlay" ).removeClass('countryOverlay-open');
        });

        $( "#furnitureOverlayCont" ).mouseleave(function() {
        	$( ".furnitureOverlay" ).removeClass('furnitureOverlay-open');
        	console.log('leaving furniture test');
        });



		$( "#showroomMenu" ).hoverIntent(function() {
            $( ".furnitureOverlay" ).removeClass('furnitureOverlay-open');
          	$( ".overlay" ).removeClass('overlay-open');
            $( ".designersOverlay" ).removeClass('designersOverlay-open');
            $( ".aboutOverlay" ).removeClass('aboutOverlay-open');
            $( ".signInOverlay" ).removeClass('signInOverlay-open');
            $( ".searchOverlay" ).removeClass('searchOverlay-open');
            $( ".countryOverlay" ).removeClass('countryOverlay-open');
        });

		

        $( ".cart-toggle" ).click(function() {
          $( ".designersOverlay" ).removeClass('designersOverlay-open');
          $( ".overlay" ).removeClass('overlay-open');
          $( ".furnitureOverlay" ).removeClass('furnitureOverlay-open');
          $( ".aboutOverlay" ).removeClass('aboutOverlay-open');
          $( ".signInOverlay" ).removeClass('signInOverlay-open');
          $( ".searchOverlay" ).removeClass('searchOverlay-open');
          $( ".countryOverlay" ).removeClass('countryOverlay-open');
        });